/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  KillswitchSchedule,
  KillswitchSchedule$Outbound,
  KillswitchSchedule$outboundSchema,
} from "./killswitchschedule.js";
import {
  KillswitchScope,
  KillswitchScope$Outbound,
  KillswitchScope$outboundSchema,
} from "./killswitchscope.js";

export type KillswitchEditRequest = {
  expectedVersion: number;
  externalNote: string;
  id: string;
  internalNote: string;
  operationId: string;
  schedule: KillswitchSchedule;
  scope: KillswitchScope;
};

/** @internal */
export type KillswitchEditRequest$Outbound = {
  expected_version: number;
  external_note: string;
  id: string;
  internal_note: string;
  operation_id: string;
  schedule: KillswitchSchedule$Outbound;
  scope: KillswitchScope$Outbound;
};

/** @internal */
export const KillswitchEditRequest$outboundSchema: z.ZodMiniType<
  KillswitchEditRequest$Outbound,
  KillswitchEditRequest
> = z.pipe(
  z.object({
    expectedVersion: z.int(),
    externalNote: z.string(),
    id: z.string(),
    internalNote: z.string(),
    operationId: z.string(),
    schedule: KillswitchSchedule$outboundSchema,
    scope: KillswitchScope$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      expectedVersion: "expected_version",
      externalNote: "external_note",
      internalNote: "internal_note",
      operationId: "operation_id",
    });
  }),
);

export function killswitchEditRequestToJSON(
  killswitchEditRequest: KillswitchEditRequest,
): string {
  return JSON.stringify(
    KillswitchEditRequest$outboundSchema.parse(killswitchEditRequest),
  );
}
